(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artapli-embroidery-tools"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('artapli-tools-carousel')) {
  customElements.define('artapli-tools-carousel', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.controller) return;
      this.track = this.querySelector('.ap-tools__grid');
      if (!this.track) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.controls = this.querySelector('.ap-tools__controls');
      this.pause = this.querySelector('.ap-tools__pause');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.hovered = false;
      this.touching = false;
      this.inView = false;
      this.prev.addEventListener('click', () => this.move(-1), {signal});
      this.next.addEventListener('click', () => this.move(1), {signal});
      this.track.addEventListener('scroll', () => this.update(), {signal, passive: true});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, {signal});
      this.pause?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.pause.textContent = this.paused ? 'Play' : 'Pause';
        this.pause.setAttribute('aria-pressed', String(this.paused));
        this.pause.setAttribute('aria-label', this.paused ? 'Start automatic carousel' : 'Pause automatic carousel');
      }, {signal});
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.hovered = true; }, {signal});
      this.addEventListener('pointerleave', () => { this.hovered = false; }, {signal});
      this.addEventListener('touchstart', () => { this.touching = true; }, {signal, passive: true});
      for (const name of ['touchend', 'touchcancel']) this.addEventListener(name, () => { this.touching = false; }, {signal, passive: true});
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.track.querySelectorAll('.ap-tools__card').forEach(card => this.observer.observe(card));
      this.visibility = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; });
      this.visibility.observe(this);
      document.addEventListener('shopify:block:select', event => {
        const card = [...this.track.children].find(item => item.dataset.blockId === String(event.detail.blockId));
        if (card) {
          this.paused = true;
          if (this.pause) { this.pause.textContent = 'Play'; this.pause.setAttribute('aria-pressed', 'true'); this.pause.setAttribute('aria-label', 'Start automatic carousel'); }
          this.track.scrollTo({left: card.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'auto'});
        }
      }, {signal});
      if (this.dataset.autoplay === 'true' && !window.Shopify?.designMode) {
        this.timer = setInterval(() => {
          if (this.paused || this.hovered || this.touching || !this.inView || document.hidden || this.motion.matches || this.contains(document.activeElement)) return;
          const max = this.track.scrollWidth - this.track.clientWidth;
          if (max <= 2) return;
          if (this.track.scrollLeft >= max - 2) this.track.scrollTo({left: 0, behavior: 'smooth'});
          else this.move(1);
        }, Math.max(3, Number(this.dataset.seconds) || 3) * 1000);
      }
      this.update();
    }
    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: this.motion.matches ? 'auto' : 'smooth'});
    }
    update() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.controls.hidden = max <= 2;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearInterval(this.timer);
      this.controller?.abort();
      this.observer?.disconnect();
      this.visibility?.disconnect();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-reviewed"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('artapli-carousel-v13')) {
 customElements.define('artapli-carousel-v13', class extends HTMLElement {
  connectedCallback() {
   const start = () => { if (this.isConnected) this.frame = requestAnimationFrame(() => this.init()); };
   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
   else start();
  }
  init() {
   this.root = this.closest('.collection');
   this.track = this.querySelector('.product-grid');
   if (!this.root || !this.track || this.controller) return;
   this.controller = new AbortController();
   const signal = this.controller.signal;
   const title = this.root.querySelector('.collection__title');
   const controls = this.querySelector('.slider-buttons');
   if (title && controls) title.append(controls);
   const viewAll = this.root.querySelector('.collection__view-all');
   const link = viewAll?.querySelector('a');
   if (title && link) { link.className = 'artapli-view-all'; title.append(link); if (controls) title.append(controls); viewAll.remove(); }
   this.prev = this.root.querySelector('.slider-button--prev');
   this.next = this.root.querySelector('.slider-button--next');
   this.prev?.addEventListener('click', () => this.move(-1), {signal});
   this.next?.addEventListener('click', () => this.move(1), {signal});
   this.track.addEventListener('scroll', () => this.update(), {signal, passive:true});
   this.track.addEventListener('keydown', event => {
    if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
    event.preventDefault(); this.move(event.key === 'ArrowLeft' ? -1 : 1);
   }, {signal});
   this.root.querySelectorAll('.product-card-wrapper > .card').forEach(card => {
    const info = card.querySelector(':scope > .card__content > .card__information');
    const heading = info?.querySelector(':scope > .card__heading');
    if (!heading || info.querySelector('.artapli-type-slot')) return;
    const slot = document.createElement('div'); slot.className = 'artapli-type-slot';
    const badge = info.querySelector('.artapli-type-badge'); if (badge) slot.append(badge);
    info.insertBefore(slot, heading);
   });
   this.root.querySelectorAll('.quick-add__submit:not([disabled])').forEach(button => {
    const label = button.dataset.productUrl ? this.root.dataset.optionsText : this.root.dataset.cartText;
    if (!label) return;
    const span = [...button.children].find(el => el.tagName === 'SPAN' && !el.className);
    if (span) span.textContent = label;
    else { const node = [...button.childNodes].find(n => n.nodeType === 3 && n.textContent.trim()); if (node) node.textContent = label; }
   });
   const align = () => {
    cancelAnimationFrame(this.alignmentFrame);
    this.alignmentFrame = requestAnimationFrame(() => {
     if (!this.isConnected) return;
     const cards = [...this.track.querySelectorAll('.card-wrapper > .card')];
     const groups = [
      ':scope > .card__content > .card__information > .artapli-type-slot',
      ':scope > .card__content > .card__information > .card__heading',
      ':scope > .card__content > .card__information .card-information > .price',
      ':scope > .card__content > .card__information .card-information',
      ':scope > .card__content > .card__information',
      ':scope > .card__content > .quick-add .quick-add__submit'
     ].map(selector => cards.map(card => card.querySelector(selector)).filter(Boolean));
     groups.flat().forEach(element => element.style.removeProperty('min-height'));
     groups.forEach(elements => {
      const height = Math.ceil(Math.max(0, ...elements.map(element => element.getBoundingClientRect().height)));
      elements.forEach(element => { element.style.minHeight = `${height}px`; });
     });
    });
   };
   this.observer = new ResizeObserver(() => {
    this.update();
    const width = this.track.getBoundingClientRect().width;
    const cardWidth = this.track.querySelector('.grid__item')?.getBoundingClientRect().width;
    if (width !== this.alignmentWidth || cardWidth !== this.alignmentCardWidth) {
     this.alignmentWidth = width;
     this.alignmentCardWidth = cardWidth;
     align();
    }
   });
   window.addEventListener('resize', align, {signal, passive:true});
   document.fonts?.ready.then(align);
   align();
   this.observer.observe(this.track);
   this.track.querySelectorAll('.grid__item').forEach(item => this.observer.observe(item));
   this.update();
   this.setupAutoplay(signal);
  }
  setupAutoplay(signal) {
   this.manualPaused = false;
   this.hovered = false;
   this.inView = true;
   this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
   const toggle = this.root.querySelector('.artapli-autoplay-toggle');
   toggle?.addEventListener('click', () => {
    this.manualPaused = !this.manualPaused;
    toggle.textContent = this.manualPaused ? 'Play' : 'Pause';
    toggle.setAttribute('aria-pressed', String(this.manualPaused));
    toggle.setAttribute('aria-label', this.manualPaused ? 'Start automatic carousel' : 'Pause automatic carousel');
   }, {signal});
   this.root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.hovered = true; }, {signal});
   this.root.addEventListener('pointerleave', () => { this.hovered = false; }, {signal});
   this.root.addEventListener('touchstart', () => { this.touching = true; }, {signal, passive:true});
   this.root.addEventListener('touchend', () => { this.touching = false; }, {signal, passive:true});
   this.root.addEventListener('touchcancel', () => { this.touching = false; }, {signal, passive:true});
   if (typeof IntersectionObserver !== 'undefined') {
    this.visibilityObserver = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; });
    this.visibilityObserver.observe(this.root);
   }
   if (this.root.dataset.autoplay !== 'true') return;
   const seconds = Math.max(3, Number(this.root.dataset.autoplaySeconds) || 5);
   this.timer = setInterval(() => this.autoplayStep(), seconds * 1000);
  }
  autoplayStep() {
   if (this.manualPaused || this.hovered || this.touching || !this.inView || document.hidden || this.reducedMotion.matches || this.root.contains(document.activeElement)) return;
   const max = this.track.scrollWidth - this.track.clientWidth;
   if (max <= 2) return;
   if (this.track.scrollLeft >= max - 2) this.track.scrollTo({left:0, behavior:'smooth'});
   else this.move(1);
  }
  move(direction) {
   const first = this.track.querySelector('.grid__item');
   if (!first) return;
   const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
   this.track.scrollBy({left: direction * (first.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }
  update() {
   const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
   if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
   if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
  }
  disconnectedCallback() { cancelAnimationFrame(this.alignmentFrame); cancelAnimationFrame(this.frame); clearInterval(this.timer); this.visibilityObserver?.disconnect(); this.controller?.abort(); this.observer?.disconnect(); this.controller = null; }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
